import { render, staticRenderFns } from "./FilterOptionAvatar.vue?vue&type=template&id=02d40ea8&scoped=true"
import script from "./FilterOptionAvatar.vue?vue&type=script&lang=ts"
export * from "./FilterOptionAvatar.vue?vue&type=script&lang=ts"
import style0 from "./FilterOptionAvatar.vue?vue&type=style&index=0&id=02d40ea8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d40ea8",
  null
  
)

export default component.exports